// form-context.ts file
import { createFormContext } from '@mantine/form';

export const [StudioFormProvider, useStudioFormContext, useStudioForm] =createFormContext();